import { getContactDisplayName } from "@/lib/email-utils"

interface ThreadNameSource {
	title?: string | null
	contact?: { name?: string | null; email?: string | null }
	company?: { name?: string | null }
}

// Names derived from an email arrive lowercase, and document.title can't lean
// on CSS capitalize. Only lifts lowercase initials, so "McDonald" survives.
function capitalizeName(value: string): string {
	return value.replace(
		/(^|[\s-])(\p{Ll})/gu,
		(_, boundary: string, letter: string) => boundary + letter.toUpperCase(),
	)
}

// The contact's name, falling back to the company's when the contact has none.
// Company names are entered deliberately, so they render verbatim.
function getThreadCustomerName(thread: ThreadNameSource): string | undefined {
	const contactName = thread.contact
		? getContactDisplayName(thread.contact)?.trim()
		: undefined
	if (contactName) return capitalizeName(contactName)

	return thread.company?.name?.trim() || undefined
}

// Browser tab, customer first. MetaInfo appends " | Productlane".
export function getThreadDocumentTitle(thread: ThreadNameSource): string {
	const parts = [getThreadCustomerName(thread), thread.title?.trim()].filter(
		Boolean,
	)
	return parts.length > 0 ? parts.join(" | ") : "Inbox"
}
